<template>
  <div>
    <div 
      @click="launchFile()">
      <slot name="activator"></slot>
    </div>

    <input 
      type="file"
      accept="image/png, image/gif, image/jpg, image/jpeg"
      ref="file"
      :name="filename"
      v-on:change="changeImage($event.target.files)"
      style="display:none">

    <v-dialog 
      v-model="dialog"
      width="500">
      <v-card
        flat>
        <v-card
          color="red accent-2">
          <v-list-item>
            <v-list-item-avatar 
              color="red accent-2" 
              size="30">
              <v-icon 
                large 
                color="white">
                mdi-alert
              </v-icon>
            </v-list-item-avatar>
            
            <v-list-item-content>
              <div
                class="caption white--text">
                {{ message.error }}
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'upload-folder',
    data: () => ({
      dialog: false,
      filename: 'file',
      message: {
        success: '',
        error: ''
      },
      process: {
        file: false
      }
    }),
    methods: {
      launchFile () {
        this.$refs.file.click()
      },
      changeImage (file) {
        let image = file[0]

        if (file.length > 0) {
          if (image.type != 'image/jpg' && image.type != 'image/jpeg' && image.type != 'image/png') {
            this.dialog = true
            this.message.error = 'Silahkan pilih gambar dengan format .jpg / .jpeg / .png'
          } else if (image.size > 5242880) {
            this.dialog = true
            this.message.error = 'Maksimal gambar 5MB'
          } else {
            // let formData = new FormData()
            //     formData.append('api-key', 'd3f8bfb9d73c9ced96c369186ea2743e')
            //     formData.append('client-key', 'apikdce584a2be25dd8ae3cc403c3532')
            //     formData.append('files[]', image)
            //     formData.append('user_id', this.$store.state.user.id)

            // this.process.file = true

            // this.$emit('input', {
            //   process: this.process.file
            // })

            // fetch(`${process.env.VUE_APP_API_CDN}image`, {
            //   method: 'POST',
            //   body: formData
            // })
            // .then(res => res.json())
            // .then(response => {
            //   this.process.file = false

            //   this.$emit('input', {
            //     id: response.data[0].id,
            //     type: response.data[0].type,
            //     data: response.data[0].data,
            //     process: this.process.file
            //   })
            // })

            let formData = new FormData()
                formData.append('key', 'image')
                formData.append('image', image)
                formData.append('client_name', 'sifasum')

            this.process.form = true
            this.$emit('input', {
              process : this.process.form
            })

            fetch(`https://cdn-1.klaten.go.id/image.php`, {
              method: 'POST',
              body: formData
            })
            .then(res => res.json())
            .then(response => {
              this.process.form = false

              this.$emit('input', {
                filename: response.data.filename,
                filepath: response.data.filepath,
                fileuri: response.data.fileuri,
                process : this.process.form
              })
            })

          }
        }
      }
    }
  }
</script>